import request from '../network';

export interface CategoryTreeItem {
  id: number;
  categoryName: string;
  parentId?: number | null;
  level?: number;
  thumbImage?: string;
  iconUrl?: string;
  description?: string;
  isShow?: boolean;
  status?: number;
  createTime?: string;
  children?: CategoryTreeItem[];
}

export interface CategoryTreeResp {
  code: number;
  msg?: string;
  data: CategoryTreeItem[];
}

export interface AddCategoryPayload {
  categoryName: string;
  parentId?: number | null;
  description?: string;
  iconUrl?: string;
  status?: number;
  id?: number;
}

export interface CategoryDetail {
  id: number;
  categoryName: string;
  parentId?: number | null;
  level?: number;
  isShow?: boolean;
  status?: number;
  thumbImage?: string;
  iconUrl?: string;
  description?: string;
  createTime?: string;
}

export interface CategoryDetailResp {
  code: number;
  msg?: string;
  data?: CategoryDetail;
}

export const getCategoryTreeApi = async (shopId: number | string): Promise<CategoryTreeResp> => {
  const res = await request<CategoryTreeResp>({
    url: `/member/royalcanin/admin/points/exchange/category/${shopId}/tree`,
    method: 'GET',
  });
  return res as unknown as CategoryTreeResp;
};

export const getCategoryDetailApi = async (
  shopId: number | string,
  id: number | string,
): Promise<CategoryDetailResp> => {
  const res = await request<CategoryDetailResp>({
    url: `/member/royalcanin/admin/points/exchange/category/${shopId}/detail/${id}`,
    method: 'GET',
  });
  return res as unknown as CategoryDetailResp;
};

export const addCategoryApi = async (shopId: number | string, data: AddCategoryPayload) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/category/${shopId}/add`,
    method: 'POST',
    data,
  });
};

export const updateCategoryApi = async (shopId: number | string, data: AddCategoryPayload) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/category/${shopId}/update`,
    method: 'POST',
    data,
  });
};

export const deleteCategoryApi = async (shopId: number | string, id: number | string) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/category/${shopId}/delete/${id}`,
    method: 'GET',
  });
};

export const moveCategoryUpApi = async (shopId: number | string, id: number | string) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/category/${shopId}/move-up/${id}`,
    method: 'GET',
  });
};

export const moveCategoryDownApi = async (shopId: number | string, id: number | string) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/category/${shopId}/move-down/${id}`,
    method: 'GET',
  });
};

export const checkCategoryHasGoodsApi = async (shopId: number | string, id: number | string) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/category/${shopId}/has-goods/${id}`,
    method: 'GET',
  });
};
